export default "<event-define-filters model=\"model[options.key]\" readonly=\"formState.readOnly\"></event-define-filters>\n";